import { render, staticRenderFns } from "./ScreenSwitch.vue?vue&type=template&id=2651d817&"
import script from "./ScreenSwitch.vue?vue&type=script&lang=js&"
export * from "./ScreenSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports